import { Switch } from '@headlessui/react';
import React, { useState } from 'react';
import { BsTrash } from 'react-icons/bs';
import { SearchEngineStyles, TopicStyles } from '../mixins/mixins';
import { StyleDropdownMenu, StyleSlider } from '../components/common';
import { SearchBarStyleValues } from '../mixins/optionsValues';
import { searchEnginesList } from '../mixins/searchenginesList';

export const SearchEngineStyle = ({
	item,
	index,
	style,
	setStyle
}: {
	item: SearchEngineStyles;
	index: number;

	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	const removeSearchEngineStyle = () => {
		if (style.searchEngines.length > 1) {
			const updatedSearchEngines = style.searchEngines.slice();
			updatedSearchEngines.splice(index, 1);
			setStyle({ ...style, searchEngines: updatedSearchEngines });
		}
	};

	return (
		<>
			<div className="flex flex-row px-10">
				<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4 w-10/12">
					<StyleDropdownMenu
						key="searchEngine"
						name={'Search Engine'}
						options={searchEnginesList}
						optionState={item.searchEngine}
						handleChange={(value: any) => {
							item = { ...item, ['searchEngine']: value };
							updateSearchEngineStyle(item, index, style, setStyle);
						}}
					/>

					<StyleDropdownMenu
						key="searchbarOptions"
						name={'Searchbar Options'}
						options={[
							{ name: 'Line', value: SearchBarStyleValues.LINE },
							{ name: 'Rectangle', value: SearchBarStyleValues.RECTANGLE },
							{ name: 'Rounded', value: SearchBarStyleValues.ROUNDED }
						]}
						optionState={item.type}
						handleChange={(value: any) => {
							item = { ...item, ['type']: value };
							updateSearchEngineStyle(item, index, style, setStyle);
						}}
					/>

					<SearchStyleToggle
						styleKey={'border'}
						name={'Has border'}
						optionState={item.border}
						item={item}
						index={index}
						style={style}
						setStyle={setStyle}
					/>

					<SearchStyleToggle
						styleKey={'colored'}
						name={'Is colored'}
						optionState={item.colored}
						item={item}
						index={index}
						style={style}
						setStyle={setStyle}
					/>

					<SearchStyleToggle
						styleKey={'openNewTab'}
						name={'Open New Tab'}
						optionState={item.openNewTab}
						item={item}
						index={index}
						style={style}
						setStyle={setStyle}
					/>

					<StyleSlider
						key={'searchengine-size'}
						id={'searchengine-size'}
						name={'Size'}
						initialValue={item.size}
						minValue={'10'}
						maxValue={'80'}
						step={'5'}
						handleChange={({ value }: { value: any }) => {
							item = { ...item, size: value };
							updateSearchEngineStyle(item, index, style, setStyle);
						}}
					/>
				</div>

				{style.searchEngines.length > 1 && (
					<div className=" my-auto w-1/12">
						<div
							className="lg:ml-16 flex justify-center items-center h-12 w-12 text-gray-800 dark:text-white
									hover:text-white hover:bg-red-400 transition-all duration-500 ease-linear
									hover:rounded-xl rounded-3xl cursor-pointer hover:shadow-lg"
							onClick={() => removeSearchEngineStyle()}
						>
							<BsTrash size="22" />
						</div>
					</div>
				)}
			</div>
			<div className="mx-auto border-t w-9/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />
		</>
	);
};

const updateSearchEngineStyle = (
	searchEngineStyle: SearchEngineStyles,
	index: number,

	style: TopicStyles,
	setStyle: (style: TopicStyles) => void
) => {
	const updatedSearchEngines = style.searchEngines.slice();
	updatedSearchEngines[index] = {
		searchEngine: searchEngineStyle.searchEngine,
		type: searchEngineStyle.type,
		border: searchEngineStyle.border,
		colored: searchEngineStyle.colored,
		size: searchEngineStyle.size,
		openNewTab: searchEngineStyle.openNewTab
	};
	setStyle({ ...style, searchEngines: updatedSearchEngines });
};

type SearchStyleToggleProps = {
	styleKey: string;
	name: string;

	item: SearchEngineStyles;
	index: number;
	optionState: boolean | undefined;

	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
};
const SearchStyleToggle = ({
	styleKey,
	name,
	item,
	index,
	optionState,
	style,
	setStyle
}: SearchStyleToggleProps) => {
	const [enabled, setEnabled] = useState(
		optionState != null ? optionState : false
	);
	const handleChange = (event: any) => {
		item = { ...item, [styleKey]: !enabled };
		updateSearchEngineStyle(item, index, style, setStyle);
		setEnabled(!enabled);
	};
	return (
		<div className="w-40 mb-8">
			<label
				about={name}
				className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
			>
				{name}
			</label>
			<Switch
				checked={enabled}
				onChange={handleChange}
				className={`${
					enabled ? 'bg-blue-600' : 'bg-gray-600'
				} relative inline-flex h-6 w-11 items-center rounded-full`}
			>
				<span
					className={`${
						enabled ? 'translate-x-6' : 'translate-x-1'
					} inline-block h-4 w-4 transform rounded-full bg-gray-200 transition-all ease-in-out duration-200`}
				/>
			</Switch>
		</div>
	);
};
